<template>
    <v-container>
            <v-form ref="form" lazy-validation>
                <v-row>
                <v-col>
                    <v-select
                        v-model="searchItem"
                        :items=searchItems
                        @change="onSearchItemChange"
                        item-text="text"
                        item-value="value"
                        id="search"
                        label="ค้นหา"
                        outlined
                    >
                    </v-select>
                </v-col>
                <v-col >
                    <v-text-field v-if="searchItem > 0" @keyup.enter.native="search"  ref="searchValue" :error="isError"  v-model="searchValue" :label="searchValueLabel"  placeholder="กรอกข้อมูลคำค้น" outlined></v-text-field></v-col>
                <v-col class="text-right">
                    <v-row>
                        <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                    </v-row>
                </v-col>
            </v-row>
            </v-form>
        <v-data-table
            :headers="headers"
            :items="items"
            class="pt-5"
            fixed-header
            height="350"
        >
            <template v-slot:top>
                <v-dialog v-model="viewDialog" max-width="1000px" persistent>
                    <EditConsumable ref="editComponent"  :mainData="mainData"  @closeDialog="close"></EditConsumable>
                </v-dialog>
                    
            </template>

            <template v-slot:item.action="{ item }">
                <v-icon
                    small
                    @click="editDataConsumable(item)"
                >
                    edit
                </v-icon>
                &nbsp;
            </template>
        </v-data-table>
    </v-container>
    
</template>

<script>

import {listStockConsumable, deleteDetailStockConsumable, getHistory} from '@/api/stock/stock-consumable-api.js'
import EditConsumable from './EditConsumable'
import numeral from 'numeral'
export default {
    name: 'Search',
    components: {
        EditConsumable
    },
    computed: {
        searchValueLabel() {
            return this.isError ? "กรุณากรอกข้อมูลคำค้น" : "";
        }
    },
    watch: {
        branchCode(val) {
            if (val) {
                this.search();
            }
        }
    },
    props: ["branchCode"],
    data: () => ({
        viewDialog: false,
        headers: [
            {text: "รหัส", value: "consumableCode"},
            {text: "ชื่อวัสดุสิ้นเปลือง", value: "consumableName"},
            {text: "Type", value: "consumableTypeText", width: "100px"},
            {text: "ราคา", value: "priceDisplay", align: "right"},
            {text: "หน่วย", value: "unitOfPrice"},
            {text: "Supplier", value: "supplierName"},
            {text: "จำนวน Stock", value: "stockRemainDisplay", align: "right"},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        items: [

        ],
        mainData: {
            stockConsumableId: 0,
            consumableType: '',
            consumableCode: '',
            consumableName: '',
            price: 0,
            unitPrice: '',
            qty: 0,
            stockRemain: 0,
            transType: 1,
            remark: ''
        },
        searchItems: [
            {text: 'ทั้งหมด', value: 0},
            {text: 'รหัสวัสดุสิ้นเปลือง', value: 1},
            {text: "ชื่อวัสดุสิ้นเปลือง", value: 2},
            {text: "Supplier", value: 3}],
        searchItem: 0,
        date: null,
        searchValue: '',
        isError: false,
        itemId: -1,
        history: []
    }),
    methods: {
        onSearchItemChange() {
            this.searchValue = '';
        },
        setDate(val) {
            this.searchValue = val;
        },
        search() {
            if (this.searchItem > 0 && !this.searchValue) {
                this.isError = true;
                this.$refs.searchValue.focus();
                return;
            }
            this.items =  Object.assign([], []);
            let val = this.searchValue;
            this.$loading(true);
            listStockConsumable(this.branchCode, this.searchItem, val).then(rs => {
                this.items = rs;
                if (this.items) {
                    this.items.forEach((e) => {
                        e.price = numeral(e.price).format('0.00');
                        e.unitPrice = numeral(e.unitPrice).format('0.00');
                        e.priceDisplay = numeral(e.price).format('0,0.00');
                        e.stockRemain = numeral(e.stockRemain).format('0.00');
                        e.stockRemainDisplay = numeral(e.stockRemain).format('0,0.00');
                    });
                }
                this.$loading(false);
            }).catch(() => {
                this.$loading(false);
            });
        },
        editDataConsumable(item) {
            this.itemId = item.consumableId;
            this.mainData = item;
            this.mainData.transType = "1";
            this.mainData.branchCode = this.branchCode;
            /*
            this.$loading(true);
            getConsumable(this.itemId).then(rs => {
                this.mainData = rs;
                this.mainData.transType = "1";
                this.$loading(false);
            });
            */
           this.viewDialog = true;
            getHistory(item.consumableCode, this.branchCode).then(rs => {
                this.$refs.editComponent.setHistory(rs);
            });
            
        },
        deleteData(item) {
            if (confirm('ต้องการลบ ' + item.consumableName + ' ใช่หรือไม่ ?')) {
                deleteDetailStockConsumable(item.stockConsumableDetailId).then(() => {
                    this.search();
                });
            }
            
        },
        close() {
            this.viewDialog = false;
            this.search();
        }
    }
}
</script>